import NewsTextElement from "@/components/ContentElements/News/Text/NewsTextElement";
import React from "react";
import {tv} from "tailwind-variants";
import {AssetFields} from "contentful";
import Link from "next/link";
import contentfulImage, {ContentfulImageSource} from "@/libs/contentful/helper/ContentfulImage";

const generateClasses = tv({
    slots: {
        root: 'group/newsTeaser',
        imgLayer: '',
        mediaClassName: '',
    },
    variants: {
        type: {
            'bigNewsTeaser': {
                root: 'block z-[2] relative mx-mobile md:mx-2xl lg:mx-auto lg:max-w-[1096px] text-center',
                imgLayer: 'z-[2] w-full h-full absolute top-[0] bg-news-img-layer newsTeaserLayer',
                mediaClassName: 'relative max-w-fill aspect-[3/4] sm:aspect-video',
            },
            'smallNewsTeaser': {
                root: 'flex flex-col gap-m w-full',
                mediaClassName: 'max-h-[445px] md:max-h-[238px] aspect-video brand-transition group-hover/newsTeaser:scale-110',
            }
        }
    },
});

interface Props {
    type?: 'bigNewsTeaser' | 'smallNewsTeaser'
    slug: string
    media: AssetFields | null
    headline: string
    contentTags: string[]
    contentType: string
    contentTypeIcon: AssetFields
    date: string
}

export default function NewsTeaser({type = 'smallNewsTeaser', slug, media, headline, contentTags, contentType, contentTypeIcon, date}:Props) {
    const {root, imgLayer, mediaClassName} = generateClasses({
        type
    });

    const link = "/newsroom/news/"+ slug
    const bigWidths = [360, 480, 768, 1096];
    const smallWidths = [360, 480, 833];

    const isBig = type === 'bigNewsTeaser';
    const widths = isBig ? bigWidths : smallWidths;

    const srcSet = widths
        .map(w => {
            const h = Math.round(w * 9 / 16);
            return `${contentfulImage(media as ContentfulImageSource, { quality: 60, format: "webp", width: w, height: h, fit: 'fill'})} ${w}w`;
        })
        .join(', ');

    const sizes =
        isBig ? '100vw' : '(max-width: 834px) 100vw, 33vw';

    const imageUrl: string = contentfulImage(media as ContentfulImageSource, {
        quality: 60,
        format: "webp",
        width: 360,
        height: Math.round((360) * 9 / 16)
    });
    const altText: string = (media?.description || '').toString();

    return (
        <Link href={link} className={root()}>
            <div className="relative overflow-hidden">
                {media &&
                    <img
                        src={imageUrl}
                        srcSet={srcSet}
                        sizes={sizes}
                        alt={altText}
                        className={`w-fill h-full object-cover ${mediaClassName()}`}
                        loading="lazy"
                    />
                }
                {type === 'bigNewsTeaser' && <div className={imgLayer()}/>}
            </div>
            <NewsTextElement newsTeaserType={type} headline={headline} contentTags={contentTags} contentTypeIcon={contentTypeIcon}
                             contentType={contentType} date={date} />
        </Link>
    )
}